import React from 'react';
import LazyLoad from '../../services/lazyLoad';
import { useMediaQuery } from '@material-ui/core';
import LargeBanner from '../../components/common/Subscription/BecomePremiumTopBar/BigBanner';
import { useSubscriptionPermission } from '../../hooks/useSubscriptionPermission';

const LazyComponent = LazyLoad({ loader: () => import('./Dashboard') });
const LazyComponentXs = LazyLoad({ loader: () => import('./DashboardMobile') });

export default function Dashboard() {
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const { hasPermission } = useSubscriptionPermission('dashboard');

  return (
    <>
      <LargeBanner permissionKey="dashboard" />

      <div className={!hasPermission ? 'blurNotSubscribed' : ''}>
        {isMobile ? <LazyComponentXs /> : <LazyComponent />}
      </div>
    </>
  );
}
